const regex = /^\s?[A-Za-z\d]+?[A-Za-z\d\s]+[A-Za-z\d]+?\s?$/;

const regexString = regex.toString().slice(1, -1);

export default regex;
export {regex, regexString};
